"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NovasModule = void 0;
const common_1 = require("../../../common");
class NovasModule extends common_1.APIModule {
    constructor(client) {
        super(client, '/novas');
    }
    downloadQRCode(novaId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([novaId, 'download-qr-code']);
            const response = yield this.client.post(endpoint, payload, {
                responseType: 'arraybuffer',
            });
            return new Blob([response.data], {
                type: response.headers['content-type'],
            });
        });
    }
}
exports.NovasModule = NovasModule;
